import {
  ArdoqId,
  MetamodelBase,
  MetamodelContent,
  PersistedMetamodel,
} from '@ardoq/api-types';
import {
  Method,
  deleteEntity,
  fetchEntities,
  fetchEntity,
  fetchJson,
  toRequestOptions,
} from './api';
import { ApiResponse } from './types';

const generate = (workspaceIds: ArdoqId[]): ApiResponse<MetamodelContent> => {
  const request = new Request(
    '/api/metamodel/generate',
    toRequestOptions(Method.POST, {
      workspaceIds,
    })
  );
  return fetchJson<MetamodelContent>(request);
};

const create = (metamodel: MetamodelBase): ApiResponse<PersistedMetamodel> => {
  const request = new Request(
    '/api/metamodel',
    toRequestOptions(Method.POST, metamodel)
  );
  return fetchJson<PersistedMetamodel>(request);
};

const update = (
  _id: ArdoqId,
  metamodel: MetamodelBase
): ApiResponse<PersistedMetamodel> => {
  const request = new Request(
    `/api/metamodel/${_id}`,
    toRequestOptions(Method.PUT, { _id, ...metamodel })
  );
  return fetchJson<PersistedMetamodel>(request);
};

const copy = (metamodel: PersistedMetamodel, newName: string) => {
  return metamodelApi.create({
    name: newName,
    workspaceIds: metamodel.workspaceIds,
  });
};

export const metamodelApi = {
  generate,
  fetchAllAssets: fetchEntities<PersistedMetamodel>('metamodel/assets'),
  fetchAll: fetchEntities<PersistedMetamodel>('metamodel'),
  create,
  update,
  fetch: fetchEntity<PersistedMetamodel>('metamodel'),
  delete: deleteEntity('metamodel'),
  copy,
};
